import { FormInstance } from 'antd/lib/form';

export const formHasErrors = (form: FormInstance<any>): boolean => {
  return form.getFieldsError().some(({ errors }) => errors.length);
};
